// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2_postcss@8.5.15_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2_postcss@8.5.15_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  min-height: 100%;
  margin: 0;
}

body {
  background: #f5f7fb;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.runtime-page {
  background: #fff;
  border-radius: 8px;
  margin: 32px auto;
  max-width: 960px;
  min-height: 560px;
  padding: 32px;
}

.runtime-page > * {
  margin-bottom: 20px;
}

.lc-material-skeleton,
.lc-material-error {
  border: 1px dashed #d9dce3;
  border-radius: 8px;
  color: #667085;
  padding: 16px;
}

.lc-material-error {
  background: #fff2f0;
  border-color: #ffccc7;
  color: #a8071a;
  display: grid;
  gap: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;EAGE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,QAAQ;AACV","sourcesContent":["html,\nbody,\n#root {\n  min-height: 100%;\n  margin: 0;\n}\n\nbody {\n  background: #f5f7fb;\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n}\n\n.runtime-page {\n  background: #fff;\n  border-radius: 8px;\n  margin: 32px auto;\n  max-width: 960px;\n  min-height: 560px;\n  padding: 32px;\n}\n\n.runtime-page > * {\n  margin-bottom: 20px;\n}\n\n.lc-material-skeleton,\n.lc-material-error {\n  border: 1px dashed #d9dce3;\n  border-radius: 8px;\n  color: #667085;\n  padding: 16px;\n}\n\n.lc-material-error {\n  background: #fff2f0;\n  border-color: #ffccc7;\n  color: #a8071a;\n  display: grid;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
